import React, { Component } from "react";
import { DashboardTabWrapper, DashboardTab } from "./styles";
import _ from "lodash";

class MultiWeekPlannerTabPicker extends Component {
  state = {
    orderedDashboard: [],
    insertTo: null,
    isSavingOrder: false,
  };

  componentDidMount() {}

  componentDidUpdate(prevProps) {}

  render() {
    const { activeDashboard, setActiveDashboard, dashboards } = this.props;

    const noActiveDashboard = _.isEmpty(activeDashboard);

    return (
      <DashboardTabWrapper width="1" bg="greyscale.4" id="DCRPDashboardTab">
        {dashboards.map(
          (dashboard, index) =>
            dashboard && (
              <DashboardTab
                key={dashboard.title}
                px={1}
                mx="1px"
                active={
                  noActiveDashboard
                    ? index === 0
                    : dashboard.title === activeDashboard.title
                }
                bg={dashboard.colour}
                color="greyscale.5"
                onClick={() => setActiveDashboard(dashboard)}
                draggable={false}
              >
                <p>{dashboard.title}</p>
              </DashboardTab>
            )
        )}
      </DashboardTabWrapper>
    );
  }
}

export default MultiWeekPlannerTabPicker;
